$(function () {
    $('.examples, .important-information').each(function (index, element) {
        if ($(element).is(':last-child')) {
            $(element).css('margin-bottom', '12px')
        }
    });
});